import React from 'react';
import { observer } from 'mobx-react-lite';
import { StoreContext } from './contexts/StoreContext';
import { RootStore } from './stores/RootStore';
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts';
import { useProjectManager } from './hooks/useProjectManager';
import { Canvas } from './components/Canvas';
import { ToolBox } from './components/ToolBox';
import { ZoomControls } from './components/ZoomControls';
import { ContextMenu } from './components/ContextMenu';
import { UndoRedoControls } from './components/UndoRedoControls';
import { ProjectPanel } from './components/ProjectPanel';
import { ExportPanel } from './components/ExportPanel';
import { IconPalette } from './components/IconPalette';
import { ClipboardPreview } from './components/ClipboardPreview';
import { useStores } from './contexts/StoreContext';
import styles from './App.module.css';

const rootStore = new RootStore();

const AppContent: React.FC = observer(() => {
  const { uiStore } = useStores();
  useProjectManager();
  useKeyboardShortcuts();
  
  return (
    <div className={styles['app']}>
      <main className={styles['appMain']}>
        <div className={styles['canvasContainer']}>
          <Canvas />
        </div>
        <ProjectPanel />
        <ExportPanel />
        <ToolBox />
        <ZoomControls />
        <UndoRedoControls />
        <ContextMenu />
        <IconPalette 
          isOpen={uiStore.activeTool === 'icon'} 
          onClose={() => uiStore.setActiveTool('select')} 
        />
        <ClipboardPreview 
          isVisible={uiStore.activeTool === 'image'} 
        />
      </main>
    </div>
  );
});

const App: React.FC = () => {
  return (
    <StoreContext.Provider value={rootStore}>
      <AppContent />
    </StoreContext.Provider>
  );
};

export default App; 